import React from 'react';
import { Clock, Car, Target, Award } from 'lucide-react';
import { commitments } from '../data/mock';

const iconMap = {
  0: Clock,
  1: Car,
  2: Target,
  3: Award
};

const Commitments = () => {
  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-start">
          {/* Image */}
          <div className="lg:col-span-2 order-2 lg:order-1">
            <div className="relative">
              <img
                src="/images/dakar-skyline.png"
                alt="Professional chauffeur"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3 order-1 lg:order-2">
            <h2
              className="text-3xl md:text-4xl text-gray-900 mb-12"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Nos engagements
            </h2>

            <div className="grid sm:grid-cols-2 gap-8">
              {commitments.map((commitment, index) => {
                const IconComponent = iconMap[index];
                return (
                  <div key={commitment.id} className="group">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-gray-900 transition-colors">
                        <IconComponent
                          size={20}
                          className="text-gray-700 group-hover:text-white transition-colors"
                        />
                      </div>
                      <div>
                        <span className="text-xs text-gray-500 uppercase tracking-wider">
                          {commitment.label}
                        </span>
                        <h3 className="text-lg font-medium text-gray-900 mb-2">
                          {commitment.title}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed">
                          {commitment.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Commitments;
